export default function AbsenceReviewTable({ summary, showTitle = true }) {
  // filter only players with absence
  const absentPlayers = summary
    .filter(p => p.absent > 0)
    .sort((a, b) => a.name.localeCompare(b.name));

  if (absentPlayers.length === 0) {
    return <p className="mt-6 text-gray-600">No absences this month 🎉</p>;
  }

  return (
    <div className="overflow-x-auto pt-4 px-6">
      {showTitle && <h1 className="mb-2">Absence Review</h1>}
      <table className="w-full text-sm border min-w-[600px]">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-2 py-1 border text-center">Player</th>
            <th className="px-2 py-1 border text-center">Absent Dates</th>
          </tr>
        </thead>
        <tbody>
          {absentPlayers.map((p, idx) => (
            <tr key={idx} className="text-left">
              <td className="px-2 py-1 border">{p.name}</td>
              <td className="px-2 py-1 border text-sm text-gray-700">
                {p.absentDates.join(", ")}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
